import request from '../../utils/request';

export function startPreview(params: { feature: string; companyId?: number; carrierId?: number; previewEnds?: Date }) {
  return request(`/premium-feature/start-preview`, {
    method: 'PATCH',
    data: params,
  });
}

export function contactMe(params: { feature: string }) {
  return request(`/premium-feature/contact`, {
    method: 'GET',
    params,
  });
}

export function getPremiumFeatures(params: { companyId: number }) {
  return request(`/premium-feature`, {
    method: 'GET',
    params,
  });
}

export function setPremiumFeatures(params: {
  companyId: number;
  previewEnds?: string;
  notes?: string;
  status?: string;
}) {
  return request(`/premium-feature`, {
    method: 'POST',
    data: params,
  });
}
